
// api단: gender = [0 => 여자, 1 => 남자, 2 => 같이, 3 => 무성(기타?)]
// export const genders = ['여자', '남자', '같이', '기타', , , , , ,];// '전체'];
// export const seasons = ['봄', '여름', '가을', '겨울', , , , , ,];// '전체'];

export const genders = {'여자':0, '남자':1, '같이':2, '기타':3};// '전체'];

export const seasons = {'봄':0, '여름':1, '가을':2, '겨울':3};// '전체'];



export const cc = {
    genders: genders,
    seasons: seasons,

};
